(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Matches
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('invoicesgenerate', invoicesgenerate);

  function invoicesgenerate($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoicesgenerate/:id', {id: '@_id'}, {
    
      query: {
        method: 'GET',
        isArray: true
    }
  });
}}());
